import { render, staticRenderFns } from "./examRequire.vue?vue&type=template&id=31b19164&scoped=true&"
import script from "./examRequire.vue?vue&type=script&lang=js&"
export * from "./examRequire.vue?vue&type=script&lang=js&"
import style0 from "./examRequire.vue?vue&type=style&index=0&id=31b19164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b19164",
  null
  
)

export default component.exports